export default __webpack_public_path__ + "static/media/Helm of Pandemonium.c529d484.jpg";